export const FETCH_USERS_AND_GROUPS_INIT = "FETCH_USERS_AND_GROUPS_INIT";
export const FETCH_USERS_AND_GROUPS_DONE = "FETCH_USERS_AND_GROUPS_DONE";
export const FETCH_USERS_AND_GROUPS_FAILED = "FETCH_USERS_AND_GROUPS_FAILED";
export const INVITATION_FAILED = "INVITATION_FAILED";
export const INVITING_USERS = "INVITING_USERS";
export const INVITED_SUCCESSFULLY = "INVITED_SUCCESSFULLY";
export const MAKE_OR_REMOVE_ADMIN_INIT = "MAKE_OR_REMOVE_ADMIN_INIT";
export const MAKE_OR_REMOVE_ADMIN_DONE = "MAKE_OR_REMOVE_ADMIN_DONE";
export const MAKE_OR_REMOVE_ADMIN_FAILED = "MAKE_OR_REMOVE_ADMIN_FAILED";
export const REMOVE_USER_INIT = "REMOVE_ADMIN_INIT";
export const REMOVE_USER_DONE = "REMOVE_USER_DONE";
export const REMOVE_USER_FAILED = "REMOVE_USER_FAILED";
export const INVITE_EMAIL_INIT = "INVITE_EMAIL_INIT";
export const INVITE_EMAIL_DONE = "INVITE_EMAIL_DONE";
export const INVITE_EMAIL_FAILED = "INVITE_EMAIL_FAILED";
export const INVITE_EMAIL_WITH_INBOX_INIT = 'INVITE_EMAIL_WITH_INBOX_INIT';
export const INVITE_EMAIL_WITH_INBOX_DONE = 'INVITE_EMAIL_WITH_INBOX_DONE';
export const FETCH_TASKS_ASSIGNED_INIT = "FETCH_TASKS_ASSIGNED_INIT";
export const FETCH_TASKS_ASSIGNED_DONE = "FETCH_TASKS_ASSIGNED_DONE";
export const FETCH_TASKS_ASSIGNED_FAILED = "FETCH_TASKS_ASSIGNED_FAILED";
export const SYNC_GSUITE_USERS_INIT = "SYNC_GSUITE_USERS_INIT";
export const SYNC_GSUITE_USERS_DONE = "SYNC_GSUITE_USERS_DONE";
export const SYNC_GSUITE_USERS_FAILED = "SYNC_GSUITE_USERS_FAILED";
export const SYNC_GSUITE_GROUPS_DONE = "SYNC_GSUITE_GROUPS_DONE";
export const SYNC_GSUITE_GROUPS_INIT = "SYNC_GSUITE_GROUPS_INIT";
export const SYNC_GSUITE_GROUPS_FAILED = "SYNC_GSUITE_GROUPS_FAILED";
export const RESET_USERS_PAGINATION = 'RESET_USERS_PAGINATION';
export const GET_ROLES_INIT = 'GET_ROLES_INIT';
export const GET_ROLES_DONE = 'GET_ROLES_DONE';
export const GET_ROLES_FAILED = 'GET_ROLES_FAILED';
export const SET_CURRENT_ROLE = 'SET_CURRENT_ROLE';
export const UNSET_CURRENT_ROLE = 'UNSET_CURRENT_ROLE';
export const ADD_ROLE_INIT = 'ADD_ROLE_INIT'
export const ADD_ROLE_DONE = 'ADD_ROLE_DONE'
export const ADD_ROLE_FAILED = 'ADD_ROLE_FAILED'
export const UPDATE_ROLE_INIT = 'UPDATE_ROLE_INIT'
export const UPDATE_ROLE_DONE = 'UPDATE_ROLE_DONE'
export const UPDATE_ROLE_FAILED = 'UPDATE_ROLE_FAILED'
export const DELETE_ROLE_INIT = 'DELETE_ROLE_INIT'
export const DELETE_ROLE_DONE = 'DELETE_ROLE_DONE'
export const DELETE_ROLE_FAILED = 'DELETE_ROLE_FAILED'
export const CHANGE_USER_ROLE_INIT = 'CHANGE_USER_ROLE_INIT'
export const CHANGE_USER_ROLE_DONE = 'CHANGE_USER_ROLE_DONE'
export const CHANGE_USER_ROLE_FAILED = 'CHANGE_USER_ROLE_FAILED'
export const SET_CURRENT_ROLE_PERMISSION = 'SET_CURRENT_ROLE_PERMISSION'
export const SET_CURRENT_ROLE_META = 'SET_CURRENT_ROLE_META'
export const RESET_CURRENT_ROLE_DATA = 'RESET_CURRENT_ROLE_DATA'
export const SET_CURRENT_ROLE_DATA = 'SET_CURRENT_ROLE_DATA'
export const DOWNLOAD_USERS_LIST = 'DOWNLOAD_USERS_LIST'
export const OPEN_ERROR_MODAL = 'OPEN_ERROR_MODAL';
export const CLOSE_ERROR_MODAL = 'CLOSE_ERROR_MODAL';